import { useShallow } from "zustand/shallow";
import { useUIStore } from "../stores/ui-store";
import { UIState } from "../types/ui-types";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { adminFetchReportById } from "../api/report.api";

interface UseReportsProps {
  reportId?: number;
  disableCache?: boolean;
}

const useAdminReport = ({
  reportId,
  disableCache = false,
}: UseReportsProps) => {
  const [bearerToken, companyId, toast] = useUIStore(
    useShallow((state: UIState) => [
      state.bearerToken,
      state.companyId,
      state.toastRef,
    ])
  );

  const query = {
    reportId: reportId as number,
    companyId: companyId as number,
    bearerToken,
  };

  const { data: reportData, isLoading: isLoadingReport } = useQuery({
    queryKey: ["reports", reportId],
    queryFn: () => adminFetchReportById(query),
    ...(disableCache && {
      staleTime: 0,
      gcTime: 0,
      refetchOnMount: "always",
    }),
  });

  return {
    reportData,
    isLoadingReport,
  };
};

export default useAdminReport;
